import React from "react";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import EventPaginatedTable from "./table/table";
import { useFormState } from "components/common";
import { ActionButtons, SearchForm } from "./list-page";
import { parseQueryParams, handleChangeSearchFormField, handleClearSearchForm } from "components/common";

const EventListPage = ({ location: { search }, history }) => {
  const [state, dispatch] = useFormState({
    startDate: null,
    endDate: null,
    deploymentId: "",
    eventStatus: "",
    eventTypeIds: [],
    showDeletedEvents: false,
    ...parseQueryParams(search),
  });

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.event.list" buttons={<ActionButtons />} />
      <PageSection spaced>
        <SearchForm
          onChange={handleChangeSearchFormField({ dispatch, search, history })}
          searchState={state}
          onClear={handleClearSearchForm({ dispatch, history })}
        />
      </PageSection>
      <PageSection spaced hideBackground>
        <EventPaginatedTable variables={state} />
      </PageSection>
    </Dashboard>
  );
};

export default EventListPage;
